import { useEffect, useState } from "react";
import {
  generateBarCode,
  saveQrCodeAndSendSms } from
"../../services/epic/bloodDonation";
import { todayDate } from "../../common/DateFormatters";
import { Loader } from "../../common/Loader";
import { initialStateBloodDonation } from "../../utils/constants";
import { v4 as uuidv4 } from 'uuid';
import formatMobileNumber from "../../common/FormatMobileNumber";

const QuestionnaireQrCode = ({
  setRequestStep,
  mobileNum,
  submittedAnswerDataRequest,
  loading,
  setLoading,
  setSubmittedAnswerData,
  cardProfile,
  setBarCode,
  handleCancel,
  translationMap
}) => {
  const [qrCode, setQrCode] = useState("");

  function generateUUID() {
    const newUUID = uuidv4();
    //console.log("Generated UUID:", newUUID);
    return newUUID;
  }

  const fetchBarCode = async () => {
    try {
      let preStepAnswerQrCodeValue = "";
      if (submittedAnswerDataRequest) {
        preStepAnswerQrCodeValue = submittedAnswerDataRequest?.qrCodeValue;
      }
      const normalizedMobileNumber = formatMobileNumber(mobileNum);
      //console.log("normalized mobile number", normalizedMobileNumber);
      let barCodeContent = "V1.0|" + normalizedMobileNumber + "|" + preStepAnswerQrCodeValue;
      const response = await generateBarCode(barCodeContent);
      //console.log("Bar code response >> ", response);
      setQrCode(response.data.barcode);
      setBarCode(response.data.barcode);
    } catch (err) {


      //console.error("Error fetching barcode:", err);
    }};
  useEffect(() => {
    fetchBarCode();
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveQrCodeSmsFun = async (uuid, qrCode, mobileNum) => {
    try {
      await saveQrCodeAndSendSms(uuid, qrCode, mobileNum);
      //console.log("response after saving details", response);
    } catch (err) {


      //console.error("Error fetching details:", err);
    }};
  useEffect(() => {
    if (qrCode)
    {
      const uuid = generateUUID();
      saveQrCodeSmsFun(uuid, qrCode, mobileNum);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrCode]);

  const handleCreateNewRequest = () => {
    if (cardProfile && cardProfile?.mobileNumber)
    {
      setRequestStep(2);
    } else
    {
      setRequestStep(1);
    }
    setSubmittedAnswerData(initialStateBloodDonation);
    window.parent.scrollTo(0, 0);
  };

  if (loading)
  {
    return (
      <Loader />);

  }
  return (
    <>
        <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
          <div className="container customContainer">
            <div className="cover_inner_wrapper">
              <div className="cover_main_box1">
                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible blood_barcode_alert_box">
                  <button type="button" className="close" data-dismiss="alert">
                    &times;
                  </button>
                  <div className="Icon_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                    <a href="javascript:void(0);">
                      <span className="material-symbols-outlined">
                        check_circle
                      </span>
                    </a>
                  </div>
                  <div className="alert_text">
                    <h6>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);">
                        {translationMap?.bloodDonationApproved}
                      </a>
                    </h6>
                    <p className="number_txt">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);">
                        {translationMap?.useQRCodeMsg}
                      </a>
                    </p>
                  </div>
                </div>
                <div className="qr_code_questionnaire_wrap">
                  <div className="bd_summary_box">
                    <div className="bd_summary_text_box">
                      <p className="date_text" style={{ direction: "ltr" }}>{todayDate()}</p>
                      <p className="Gray_Title bottom_text bottom_text_italic">
                        {translationMap?.codeValidToday}
                      </p>
                    </div>
                    <div className="bd_summary_icon_box">
                      <img
                      src={`data:image/png;base64,${qrCode}`}
                      alt="Displaying barcode" />
                    
                    </div>
                  </div>
                  <div className="questionire_btn_box">
                    <span>
                      <button
                      onClick={handleCancel}
                      className="bluetrans_btn_link">
                      
                        {translationMap?.backToDammi}
                      </button>
                    </span>
                    <span>
                      <button
                      onClick={handleCreateNewRequest}
                      className="bluetrans_btn_link">
                      
                        {translationMap?.createNewRequest}
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="cover_main_box2"></div>
            </div>
          </div>
        </section>
    </>);

};

export default QuestionnaireQrCode;